module.exports = __webpack_public_path__ + "static/media/spliceTwo_sl.478c1881.png";